
<script>
  import Field from "./field.svelte";
  import { scaleSqrt } from 'd3-scale';

  export let isIso = true;
  export let size = 10;
  export let type = "houses";
  export let data = {};
  export let districtName = "";

  const width = 200;
  const gridSize = 20;

  $: sizes = [
    size,
    +data.country[type + "_ave"],
    +data.region[type + "_ave"],
    +data.la[type + "_ave"]
  ]

  $: sortedSizes = sizes.slice(0).sort((a, b) => b - a);

  $: scale = scaleSqrt().range([0, 200]).domain([0, 800]);
  $: gridlines = Math.round(800 / gridSize);
</script>

<svg class:isIso class="container">
  <rect class="field" width="{scale(sizes[0])}" height="{scale(sizes[0])}" x="{width - scale(sizes[0])}" y="{width - scale(sizes[0])}"></rect>
  <rect class="outline country" width="{scale(sizes[1])}" height="{scale(sizes[1])}" x="{width - scale(sizes[1])}" y="{width - scale(sizes[1])}"></rect>
  <rect class="outline region" width="{scale(sizes[2])}" height="{scale(sizes[2])}" x="{width - scale(sizes[2])}" y="{width - scale(sizes[2])}"></rect>
  <rect class="outline la" width="{scale(sizes[3])}" height="{scale(sizes[3])}" x="{width - scale(sizes[3])}" y="{width - scale(sizes[3])}"></rect>
  {#each Array(gridlines).fill(0) as line, i}
    <line x1={(i * gridSize)} x2={(i * gridSize)} y1={0} y2={width} />
    <line y1={(i * gridSize)} y2={(i * gridSize)} x1={0} x2={width} />
  {/each}
</svg>

<ul class="legend">
  <li class="country">{data.country.Country} - {+data.country[type + "_ave"]}m<sup>2</sup></li>
  <li class="region">{data.region["Region name"]} - {+data.region[type + "_ave"]}m<sup>2</sup></li>
  <li class="la">{data.la["LAD name"]} - {+data.la[type + "_ave"]}m<sup>2</sup></li>
  <li class="area">{districtName} - {size}m<sup>2</sup></li>
</ul>

<style>
  svg.container {
    width: 200px;
    height: 200px;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: transform 0.5s;
  }

  svg.isIso {
    transform: rotateX(60deg) rotateY(0deg) rotateZ(-45deg);
  }

  rect.outline {
    fill: none;
    stroke-width: 4px;
  }

  .country {
    stroke: #c1002a;
  }

  .region {
    stroke: #0063E6;
  }

  .la {
    stroke: #E6B217;
  }

  ul {
    position: absolute;
    bottom: -85px;
    left: 0;
    font-size: 0.75em;
    padding: 0;
  }

  li {
    list-style: none;
    padding-left: 8px;
  }

  li.country {
    border-left: 10px solid #c1002a;
  }

  li.region {
    border-left: 10px solid #0063E6;
  }

  li.la {
    border-left: 10px solid #E6B217;
  }

  li.area {
    border-left: 10px solid #7ec850;
  }

  rect.field {
    fill: #7ec850;
    stroke-width: 3px;
  }
  line {
    stroke: #ccc;
  }
</style>